import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { Environment } from '@galaxy/core';
import { ListReportsByCategoryResponseCategoryWithReports, Report } from '@vendasta/data-warehouse';

export interface ReportWithFavorite extends Report {
  isFavorite?: boolean;
}

export interface CategoryWithReportsAndId extends ListReportsByCategoryResponseCategoryWithReports {
  id: string;
  reports: ReportWithFavorite[];
  errorMsg?: string;
}

export interface ReportingConfig {
  partnerId$: Observable<string>;
  getEnvironment: () => Environment;
  sessionId$: Observable<string>;
  userId$: Observable<string>;
  reportsUrl: string;
}

export const REPORTING_CONFIG_TOKEN = new InjectionToken<ReportingConfig>('[reports]: token for config');
